import { render, staticRenderFns } from "./IncidentReportPreviewPanel.vue?vue&type=template&id=bdbb5652&scoped=true"
import script from "./IncidentReportPreviewPanel.vue?vue&type=script&lang=js"
export * from "./IncidentReportPreviewPanel.vue?vue&type=script&lang=js"
import style0 from "./IncidentReportPreviewPanel.vue?vue&type=style&index=0&id=bdbb5652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbb5652",
  null
  
)

export default component.exports